(function ($) {
/*
  if (typeof(MP) !== 'undefined') {
    if(MP.mp_link_1 !== '') {
      var html = '<a href="' + MP.mp_link_1 + '" onclick="' + MP.mp_action_1 + '">' + MP.mp_label_1 + '<a>';
      $('.mp_lang_1').html(html);
      $('.mp_lang_2').html(MP.mp_label_2);
    } else {
      var html = '<a href="' + MP.mp_link_2 + '" onclick="' + MP.mp_action_2 + '">' + MP.mp_label_2 + '<a>';
      $('.mp_lang_1').html(MP.mp_label_1);
      $('.mp_lang_2').html(html);
    }
  }
*/
})(jQuery);
